import { useToast } from "@chakra-ui/react";

import { INotification } from "./types/INotification";

export const useNotification = () => {
  const toast = useToast();

  const addNotification = ({
    title,
    description,
    type,
    options,
  }: INotification) => {
    toast({
      position: "top",
      title: title,
      description: description,
      status: type,
      duration: 5000,
      isClosable: true,
      ...options,
    });
  };

  return { addNotification, toast };
};
